import styled from 'styled-components';
import Slider from 'react-slick/lib';

export default styled(Slider)``;
